  // npm install --save firebase
  // import * as firebase from "firebase";

  // import firebase from 'firebase/app'
  // import 'firebase/database';
  // import 'firebase/auth';

  import firebase from 'firebase/compat/app'
  import 'firebase/compat/database';
  import 'firebase/compat/auth'; 

  var firebaseConfig = {
    apiKey: "AIzaSyBho4kdWtJGqVypNRddnlPWo03Q9jZF-ik",
    authDomain: "tulkuajam-org.firebaseapp.com",
    databaseURL: "https://tulkuajam-org.firebaseio.com",
    projectId: "tulkuajam-org",
    storageBucket: "tulkuajam-org.appspot.com",
    messagingSenderId: "613338063571",
    appId: "1:613338063571:web:fe611cd844ceda3936aa26"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  export const fb =  firebase;
//   export default firebase;